var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shown,
      expression: "shown"
    }],
    staticClass: "absolute h-10 w-10 bg-pink-600 text-white flex flex-row justify-center items-center rounded-full cursor-pointer left-19/20 top-9/10 transform hover:scale-200",
    staticStyle: {
      "z-index": "500",
      "transition": "all .5s ease-in-out"
    },
    attrs: {
      "id": "toggle-onboarding"
    },
    on: {
      "click": _vm.clicked
    }
  }, [_c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }